(ns common.schema.entities.sample-entity.schema
  (:require
   [common.schema.entities.sample-entity.options :as options]
   [common.schema.schema-utils :as su]))

(defn- complex-data-field
  [attribute label data-type editor-type]
  (su/text-edn-field
   attribute
   label
   {:field/data-type          data-type
    :validation-spec          any?
    :field/default-visibility {:editor           editor-type
                               :grid             :editor.type/none
                               :filter           :filter.type/none
                               :field-visibility :not-in-use}
    :ui/default-editor-type   editor-type
    :ui/allowed-editor-types  #{editor-type}
    :ui/default-filter-type   :filter.type/none
    :ui/allowed-filter-types  #{}}))

(defn- id-data-type-field
  [attribute label]
  (su/integer-field
   attribute
   label
   {:field/data-type          :data.type/id
    :field/default-visibility {:editor           :editor.type/select
                               :grid             :editor.type/select
                               :filter           :filter.type/text
                               :field-visibility :not-in-use}
    :validation-spec          number?
    :ui/default-editor-type   :editor.type/select
    :ui/allowed-editor-types  #{:editor.type/select}
    :ui/default-filter-type   :filter.type/text
    :ui/allowed-filter-types  #{:filter.type/text}}))

(def schema
  (vec
   (concat
    (su/text-simple-field
     :sample-entity/name
     "Name"
     {:default-field-visibility :in-use
      :system-required?         true
      :system-semantics
      su/user-provided-system-required-field-semantics
      :mandatory-config         :mandatory/always
      :name-attribute           :sample-entity/name
      :not-clearable?           true})

    (su/boolean-field :sample-entity/dt-boolean "Boolean" {})
    (su/currency-symbol-field-not-secondary :sample-entity/dt-currency-symbol "Currency symbol" {})
    (su/currency-value-field :sample-entity/dt-currency-value "Currency value" {})
    (su/datetime-field :sample-entity/dt-datetime "Date time" {})
    (su/date-field :sample-entity/dt-date "Date" {})
    (su/integer-field :sample-entity/dt-date-year "Date year" {:field/data-type :data.type/date-year})
    (su/email-field-multi :sample-entity/dt-email-multi "Email list" {})
    (su/email-field :sample-entity/dt-email "Email" {})

    ;; Keep separate test coverage for text variants.
    (su/text-simple-field
     :sample-entity/dt-text
     "Text"
     {:field/data-type          :data.type/text
      :field/default-visibility {:editor           :editor.type/textarea
                                 :grid             :editor.type/textarea
                                 :filter           :filter.type/text
                                 :field-visibility :not-in-use}
      :ui/default-editor-type   :editor.type/textarea
      :ui/allowed-editor-types  #{:editor.type/text-simple :editor.type/textarea}})

    (su/text-simple-multi-field :sample-entity/dt-text-multi "Text list" {})
    (su/url-field-multi :sample-entity/dt-url-multi "URL list" {})
    (id-data-type-field :sample-entity/dt-id "ID")
    (su/integer-field :sample-entity/dt-integer "Integer" {})
    (su/keyword-multi-field :sample-entity/dt-keyword-multi "Keyword list" options/sample-tags-options {})
    (su/keyword-field :sample-entity/dt-keyword "Keyword" options/sample-status-options {})
    (su/long-field :sample-entity/dt-long "Long" {})
    (su/numeric-field :sample-entity/dt-number "Number" {})
    (su/percentage-field :sample-entity/dt-percentage "Percentage" {})
    (su/multiplier-field :sample-entity/dt-multiplier "Multiplier" {})
    (su/multi-ref-field :sample-entity/dt-ref-multi "Reference list" [:entity.type/account] {})
    (su/single-ref-field :sample-entity/dt-ref-single "Reference" [:entity.type/account] {})
    (su/text-edn-field :sample-entity/dt-text-edn "Text EDN" {})

    (complex-data-field :sample-entity/dt-financials "Financials" :data.type/financials :editor.type/financials)
    (complex-data-field :sample-entity/dt-tesi-financials "TESI financials" :data.type/tesi-financials :editor.type/tesi-financials)
    (complex-data-field :sample-entity/dt-tesi-financials-2 "TESI financials 2" :data.type/tesi-financials-2 :editor.type/tesi-financials-2)

    (su/text-multiline-field :sample-entity/dt-text-multiline "Text multiline" {})
    (su/text-wysiwyg-field :sample-entity/dt-text-richtext "Text richtext" {})
    (su/text-simple-field :sample-entity/dt-text-simple "Text simple" {})
    (su/url-field :sample-entity/dt-text-url "Text URL" {})
    (su/single-ref-field :sample-entity/dt-attachment "Attachment" [:entity.type/attachment] {}))))
